import IssuesService from 'src/modules/issues/issuesService';
import selectors from 'src/modules/issues/list/issuesListSelectors';
import { i18n } from 'src/i18n';
import exporterFields from 'src/modules/issues/list/issuesListExporterFields';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';
import Message from 'src/view/shared/message';

const prefix = 'ISSUES_LIST';

const issuesListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  SELECTEDS_CHANGED: `${prefix}_SELECTEDS_CHANGED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doChangeSelected(payload) {
    return {
      type: issuesListActions.SELECTEDS_CHANGED,
      payload,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: issuesListActions.RESETED,
    });

    dispatch(issuesListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: issuesListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await IssuesService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );

      new Exporter(
        exporterFields,
        i18n('entities.issues.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: issuesListActions.EXPORT_SUCCESS,
      });

      Message.success(
        i18n('common.exported.success'),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: issuesListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePaginationAndSort: (pagination, sorter) => async (
    dispatch,
    getState,
  ) => {
    dispatch({
      type: issuesListActions.PAGINATION_CHANGED,
      payload: pagination,
    });

    dispatch({
      type: issuesListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(issuesListActions.doFetchCurrentFilter());
  },

  doFetchCurrentFilter: () => async (
    dispatch,
    getState,
  ) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(issuesListActions.doFetch(filter, rawFilter, true));
  },

  doFetch: (filter?, rawFilter?, keepPagination = false) => async (
    dispatch,
    getState,
  ) => {
    try {
      dispatch({
        type: issuesListActions.FETCH_STARTED,
        payload: { filter, rawFilter, keepPagination },
      });

      const response = await IssuesService.list(
        filter,
        selectors.selectOrderBy(getState()),
        selectors.selectLimit(getState()),
        selectors.selectOffset(getState()),
      );

      dispatch({
        type: issuesListActions.FETCH_SUCCESS,
        payload: {
          rows: response.rows,
          count: response.count,
        },
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: issuesListActions.FETCH_ERROR,
      });
    }
  },

  doFetchAll: (filter?, rawFilter?, keepPagination = false) => async (
    dispatch,
    getState,
  ) => {
    try {
      dispatch({
        type: issuesListActions.FETCH_STARTED,
        payload: { filter, rawFilter, keepPagination },
      });

      const response = await IssuesService.list(
        filter,
        selectors.selectOrderBy(getState()),
        0,
        0,
      );

      dispatch({
        type: issuesListActions.FETCH_SUCCESS,
        payload: {
          rows: response.rows,
          count: response.count,
        },
      });

    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: issuesListActions.FETCH_ERROR,
      });
    }
  },  
};

export default issuesListActions;
